export const PLUGIN_KEY = 'com.atlassian.confluence.plugins.confluence-frontend-support';

export const PAGE_MIGRATION_FEATURE_KEY = 'confluence.fabric.page.migration.banner';

export const LEARN_MORE_URL =
	'https://confluence.atlassian.com/confcloud/converting-pages-to-the-new-editor-993930226.html';
